module.exports = __webpack_public_path__ + "static/media/hamilton-robson.1229e328.png";